import { forwardRef, type Ref, type SVGProps } from "react";
const IconMapFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M12 3v23l8 3V6zm-2 23-5.5 1.4a2 2 0 0 1-2.5-2V6.6a2 2 0 0 1 1.5-2L10 3zm12 3 6.7-2.5a2 2 0 0 0 1.3-1.9V6a2 2 0 0 0-2.7-2L22 6z" />
  </svg>
);
const ForwardRef = forwardRef(IconMapFilledSVG);
ForwardRef.displayName = "IconMapFilled";
export { ForwardRef as IconMapFilled };
